import { useCallback } from "react";

import { useDealerAccountInfo } from "../../../../../stores/hooks/useDealerAccountInfo";
import { createQueryCustomHook } from "../../../../../stores/useQueryState";

export type TireSeason = 0 | 1 | 2;

const validSeasons = new Set([0, 1, 2]);

type Validator = (value: unknown) => TireSeason;

const useValidateTireSeason = (): Validator => {
  const { dealerDefaultSearchSeason } = useDealerAccountInfo();
  return useCallback(
    (value: unknown) => {
      const season = Number(value);
      const defaultSeason = Number(dealerDefaultSearchSeason);
      if (validSeasons.has(season)) {
        return season as TireSeason;
      }
      if (validSeasons.has(defaultSeason)) {
        return defaultSeason as TireSeason;
      }
      return 0;
    },
    [dealerDefaultSearchSeason]
  );
};

export const useTireSeason = createQueryCustomHook(
  "season",
  useValidateTireSeason
);
